import { useMemo } from 'react'

import { IconKey, SiteMap } from '@swaggerhub-portal/component-library'
import { useTranslation } from 'react-i18next'

import { TopBarMenuLink } from '~/components/TopBarMenuLink'
import { useApiHubPlan } from '~/hooks/useApiHubPlan.ts'
import { useAppConfig } from '~/hooks/useAppConfig'
import { useEnvironment } from '~/hooks/useEnvironment'
import { Environment } from '~/types/app'

const getProfileLinks = ({ platformUiUrl, shubAppUrl, isOnPrem, platformManaged, swaggerhubOrgId }: { platformUiUrl: string, shubAppUrl: string, isOnPrem: boolean, platformManaged?: boolean, swaggerhubOrgId: string }) => [
  {
    icon: <SiteMap />,
    label: 'components.profile.buttons.myOrganizations.label',
    href: isOnPrem || !platformManaged ? `${shubAppUrl}/settings/organizations` : `${platformUiUrl}/organizations/${swaggerhubOrgId}/members`,
    isExternal: true
  },
  {
    icon: <IconKey width={16} height={16} />,
    label: 'components.profile.buttons.APIKey.label',
    href: `${shubAppUrl}/settings/apiKey`,
    isExternal: true
  },
]

export const ProfileSettings = ({ swaggerhubOrgId }: { swaggerhubOrgId: string }) => {
  const { shubAppUrl, platformUiUrl } = useAppConfig()
  const env = useEnvironment()
  const { platformManaged } = useApiHubPlan() || {}
  const profileLinks = useMemo(() => getProfileLinks({ platformUiUrl, shubAppUrl, isOnPrem: env === Environment.ON_PREM, platformManaged, swaggerhubOrgId }), [])

  const { t } = useTranslation()

  return <>
    <div className="mx-4 border-b border-b-neutral-20 dark:border-b-neutral-80" />
    {profileLinks.map(profileLink => (
      <TopBarMenuLink key={t(profileLink.label)} icon={profileLink.icon} label={t(profileLink.label)} href={profileLink.href} isExternal={profileLink.isExternal} />)
    )}
  </>
}